import { mapGetters } from 'vuex';

export default {
    name: 'breadcrumbs',
    data() {
        return {
            list: {},
        }
    },
    computed: {
        showComponents() {
            if (this.$route.name !== 'home') {
                return true
            }
        },
        ...mapGetters({
            translations: 'setting/translations'
        }),
        isPageCatalog(){
            return this.$route.fullPath.includes('categories')
        },
        isNotFoundPage(){
            if (this.$route.fullPath.includes('not-found')) {
                return true;
            }else{
               return false;
            }
        }
    },
    updated() {
        setTimeout(() => {
            this.list = this.$route.meta.breadcrumb;
        }, 300);
    },
    watch: {
        '$route'() {
            this.$nextTick(() => {
                this.list = this.$route.meta.breadcrumb;
            });
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.list = this.$route.meta.breadcrumb;
        })
    }
}
